<div class="p-grid header-template">
  <div class="disp-icon">
    <fa-icon icon="home"></fa-icon>
  </div>
  <div class="p-col header-info">
    <div class="p-grid p-justify-between">
      <div class="p-col-9 property-search-address">
        <span class="property-search-address-main">
          {{property.Address.Address1}} {{property.Address.Address2}}
        </span>
        {{property.Address.City}}, {{property.Address.State}} {{property.Address.PostalCode}}
        <span class="fav-icon-left">
          <i #favIconEl
            [attr.data-fav-loan-icon-id]="'fav-loan-' + property.PropertyId" 
            [attr.data-fav-loan-flag]="property.IsFavorite"
            [ngClass]="getFavIconClass(property.IsFavorite)" 
            (click)="updateFavorite(favIconEl, property.PropertyId)">
          </i>
        </span>
      </div>
      <div class="p-col-3 strategy-corner strategy-corner-fcbk">{{property.DispositionStrategyGroup}}</div>
    </div>
    <div class="p-grid">
      <div class="p-col-2"><span class="property-search-label">FC Milestone</span><br/><span class="property-search-values">{{property.FCMilestone || 'Missing'}}</span>
        <span (mouseover)="fcMilestoneHover($event,op1,property.PropertyId)" (mouseout)="op1.hide()" (click)="op1.hide()"><i class="pi pi-info-circle pointer" style="font-size:18px"
            pTooltip=""></i></span>
      </div>
      <div class="p-col-2"><span class="property-search-label">Foreclosure Type</span> <br/><span class="property-search-values"><a href="{{routes?.viewTasks}}&property_id={{property.PropertyId}}">{{property.ForeclosureType}}</a></span></div>      
      <div class="p-col-2"><span class="property-search-label">Foreclosure Status</span><br/><span class="property-search-values">{{property.ForeclosureStatus || 'Missing'}}</span></div>
      <div class="p-col-2"><span class="property-search-label">Bankruptcy Chapter</span><br/><span class="property-search-values">{{property.BankruptcyChapter || 'Missing'}}</span></div>
      <div class="p-col-2"><span class="property-search-label">Bankruptcy Status</span><br/><span class="property-search-values">{{property.BankruptcyStatus || 'Missing'}}</span></div>                   
      <div class="p-col-2"><span class="property-search-label">Parcel#</span><br/><span class="property-search-values">{{property.ParcelNumber || 'Missing'}}</span></div>                   
    </div>
    <div class="p-grid">
      <div class="p-col-3">
        <span class="property-search-label">Loan Number</span><br/>
        <span *ngIf="!showPropertyIdLink; else propertyIdLink" class="property-search-values">
          {{property.LoanNumber}}
        </span>
        <ng-template #propertyIdLink>
          <span class="property-search-values">
            <a href="{{routes?.viewTasks}}&property_id={{property.PropertyId}}">{{property.LoanNumber}}</a>
          </span>
        </ng-template>
        &nbsp;
        <a *ngIf="showOpenNewWindowIcon" href="{{routes?.viewTasks}}&property_id={{property.PropertyId}}" target="_blank">
            <i class="pi pi-external-link"></i>
        </a>
      </div>
      <div class="p-col-3"><span class="property-search-label">Status</span><br/><span class="property-search-values">{{property.StatusLabel}}</span></div>
      <div class="p-col-3"><span class="property-search-label">Partnership</span><br/><span class="property-search-values">{{property.Lender.PublicName}}</span></div>
      <div class="p-col-3"><span class="property-search-label">Investor ID/Name</span><br/><span class="property-search-values">{{property.InvestorId}} / {{property.InvestorName}}</span></div>
      
    </div>  
    <p-overlayPanel #op1 appendTo="body" [dismissable]="true" [showCloseIcon]="false" styleClass="reo-change-history-overlay">
      <div class="change-history">
        <h2>{{property.FCMilestone}}</h2>
        <table>
         <tr>
            <th width="35%">FC Milestone</th>
            <th width="10%">Target Start</th>
            <th width="10%">Actual Start</th>
            <th width="10%">Target Complete</th>
            <th width="10%">Actual Complete</th>
            <th width="5%">Target Days</th>
            <th width="5%">Hold Days</th>
            <th width="5%">Reproject Days</th>
            <th width="5%">Gross Days</th>
            <th width="5%">Net Days</th>
          </tr>
          <tr *ngFor="let FCMilestone of fcMilestoneChangeLog">
            <td>{{FCMilestone.Milestone_Name}}</td>
            <td>{{FCMilestone.Target_Start_Date}}</td>
            <td>{{FCMilestone.Actual_Start_Date}}</td>
            <td>{{FCMilestone.Target_End_Date}}</td>
            <td>{{FCMilestone.Actual_Completion_Date}}</td>
            <td>{{FCMilestone.Target_Days}}</td>
            <td>{{FCMilestone.Hold_Days}}</td>
            <td>{{FCMilestone.Reproject_Days}}</td>
            <td>{{FCMilestone.Gross_Days}}</td>
            <td>{{FCMilestone.Net_Days}}</td>
          </tr>
        </table>
      </div>
    </p-overlayPanel>
  </div> 
</div>
